import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { BreadcrumbSection } from '~/views';

class BreadcrumbView extends React.Component {
  
  static propTypes = {
    breadcrumbs : PropTypes.array
  }
  
  render() {
    const { history, breadcrumbs, children } = this.props
    return <BreadcrumbSection history={history} breadcrumbs={breadcrumbs || []}>{children}</BreadcrumbSection>
  }
}

export default withRouter( connect(
  state => ( {
    breadcrumbs : state.breadcrumbs
  } )
)( BreadcrumbView ) );
